<template>
    <div>
        <template v-if="view_attendance_correction === true && data !== null">
            <div class="clearfix">
                <div class="page-top mb-1 mb-3 align-center clearfix">
                    <h1 class="float-left"> Attendance Correction </h1>
                </div>
                <div class="global-main">
                    <div class="attandance-correction">
                        <div class="attancance-correction-head mb-3 clearfix">
                            <div class="image-holder">
                                <img :src="data.user.picture" alt="" />
                            </div>
                            <div class="title-holder">
                                <h2> {{data.user.name}} </h2>
                                <span class="attandance-status"> {{data.user.current_status}} </span>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-sm-3">
                                <span class="title"> Date </span>
                                <p> {{data.user.attendance_time}} </p>
                            </div>
                            <div class="col-sm-3">
                                <span class="title"> Type </span>
                                <p> {{data.user.attendance_type}} </p>
                            </div>
                            <div class="col-sm-3">
                                <span class="title"> Time in </span>
                                <p> {{data.user.time_in}} </p>
                            </div>
                            <div class="col-sm-3">
                                <span class="title"> Time out </span>
                                <p> {{data.user.time_out}} </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <span class="title"> Message </span>
                                <p> {{data.user.message}}</p>
                            </div>
                        </div>
                        <h3 class="mt-3 mb-4"> History </h3>
                        <div class="row" v-if="flag == true">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <!-- 12-hour sample 1 -->
                                    <label class="label block-label"> Time In: </label>
                                    <vue-timepicker name="timeIn" format="hh:mm A" input-class="form-control" v-model="form.timeIn" :class="{ 'is-invalid': form.errors.has('timeIn') }"></vue-timepicker>
                                    <has-error :form="form" field="timeIn"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <!-- 12-hour sample 1 -->
                                    <label class="label block-label"> Time Out: </label>
                                    <vue-timepicker name="timeOut" format="hh:mm A" input-class="form-control" v-model="form.timeOut" :class="{ 'is-invalid': form.errors.has('timeOut') }"></vue-timepicker>
                                    <has-error :form="form" field="timeOut"></has-error>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                 <label class="label block-label"> Message: <em class="required">*</em></label>
                                    <textarea name="message" :class="{ 'is-invalid': form.errors.has('message') }" class="form-control" placeholder="Message" v-model="form.message"></textarea>
                                    <has-error :form="form" field="message"></has-error>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="flag == true">
                            <div class="col-md-12 text-right">
                                <button class="btn btn-primary mr-1" :disabled="form.busy" @click="attendanceCorrectionHistoryUpdate(2)"> Reject </button>
                                <button class="btn btn-primary" :disabled="form.busy" @click="attendanceCorrectionHistoryUpdate(1)"> Approve </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="view_attendance_correction === null && data === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="view_attendance_correction === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>
<script>
// Main JS (in UMD format)
import VueTimepicker from 'vue2-timepicker';
// CSS
import 'vue2-timepicker/dist/VueTimepicker.css';
    export default {
        components: {
            VueTimepicker
        },
        data() {
            return {
                id: this.$route.params.id,
                data: null,
                view_attendance_correction: null,
                flag: false,
                form : new Form({
                    approvalType: null,
                    attendanceCorrectionId: this.$route.params.id,
                    message: null,
                    timeIn: '',
                    timeOut: ''
                })
            };
        },
        created (){
        },
        mounted() {
            this.viewAttendacneCorrection();
            this.$global.getName();
        },
        methods: {
            viewAttendacneCorrection(){
                let that = this;
                that.$Progress.start();
                axios.get('/api/viewAttendanceCorrection/'+that.$route.params.id)
                .then(res => {
                    that.data = res.data;
                    if(res.data){
                        this.form.timeIn = that.data.user.time_in;
                        this.form.timeOut = that.data.user.time_out;
                        that.view_attendance_correction = res.data.view_attendance_correction;
                        if(res.data.flag == true){
                            that.flag = true;
                        }else{
                            that.flag = false;
                        }
                    }else{
                        that.view_attendance_correction = false;
                        that.flag = false;
                    }
                    that.$Progress.finish();
                }).catch(err => {
                    console.log(err);
                });
            },
            attendanceCorrectionHistoryUpdate(type){
                if(type == 1){
                    this.form.approvalType = "APPROVED";
                }else{
                    this.form.approvalType = "REJECT";
                }
                this.form.post('/api/attendanceCorrectionHistoryUpdate').then(res => {
                    if(res.status == 200){
                        this.showToastBox('success','Attendance correction has been updated');
                        this.$router.push('/listAttendanceCorrection');
                    }else{
                        this.showAlertBox('error','Some problem in your form data');
                    }
                }).catch(err => {
                    this.showAlertBox('error','Some problem in your form data');
                });
            }
        },
    }
</script>
